'use client';

import { Button } from '@/components/ui/button';
import { NAV_ITEMS } from '@/config/navigation-items';
import { cn } from '@/lib/utils';

type NavMobileProps = {
  isOpen: boolean;
  onToggle: () => void;
  scrollToSection: (sectionId: string) => void;
  activeSection: string;
};

export default function NavMobile({
  isOpen,
  onToggle,
  scrollToSection,
  activeSection,
}: NavMobileProps) {
  return (
    <div className="md:hidden">
      {/* Fullscreen Menu */}
      <div
        className={cn(
          'bg-background/95 fixed inset-0 z-90 flex h-screen w-screen flex-col items-center justify-center space-y-8 backdrop-blur-md transition-opacity duration-300',
          isOpen ? 'visible opacity-100' : 'invisible opacity-0'
        )}
      >
        {NAV_ITEMS.map((item) => (
          <button
            key={item.id}
            onClick={() => {
              scrollToSection(item.id);
              onToggle();
            }}
            aria-current={activeSection === item.id ? 'page' : undefined}
            className={cn(
              'relative text-2xl font-medium transition hover:scale-105 hover:cursor-pointer',
              activeSection === item.id
                ? 'text-foreground'
                : 'text-muted-foreground hover:text-foreground'
            )}
          >
            {item.label}
            <span
              className={cn(
                'bg-primary absolute -bottom-1 left-0 h-[2px] w-0 transition-all duration-300',
                activeSection === item.id && 'w-full'
              )}
            />
          </button>
        ))}

        <Button size="lg" variant="outline" asChild>
          <a
            href="/resume.pdf"
            target="_blank"
            rel="noopener"
            aria-label="Download Resume"
          >
            Resume
          </a>
        </Button>
      </div>
    </div>
  );
}
